import Components from "slotworks/components/components";
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";

export default class StickSymbolBehaviour extends AbstractSymbolBehaviour {
    public stick() {
        Components.matrix.addStuckSymbol(this.symbol);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/matrix/symbol/behaviours/stick-symbol-behaviour.ts